import { Directive, EventEmitter, HostListener, Inject, Input, Output, AfterViewChecked, OnDestroy, Renderer2 } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Directive({
  selector: '[acnScrollDetectSpy]'
})
export class ScrollDetectSpyDirective implements AfterViewChecked, OnDestroy {

  @Input() public spyItems : any[];
  @Input() public scrollContainer: string;
  @Input() public scrollOffset: number = 0;
  @Output() public sectionChange = new EventEmitter<string>();
  private currentSection: string;

  private scrollListener: () => void;
  constructor(private renderer2: Renderer2, @Inject(DOCUMENT) private document: any) {
  }
  ngAfterViewChecked() {
    if (this.scrollContainer && !this.scrollListener) {
      let scrollContainerElement;
      // Get container where scrolling is detected
      if (this.scrollContainer === "body") {
        scrollContainerElement = this.document.body;
      } else {
        scrollContainerElement = this.document.getElementById(this.scrollContainer)
      }
      // If container exists then and scroll listener and start detecting changes when scrolling.
      if (this.scrollContainer === "window" ) {
        this.scrollListener = this.renderer2.listen('window', "scroll", event => {
          this.detectScrollPosition(event);
        });
      } else
      if (scrollContainerElement) {
        this.scrollListener = this.renderer2.listen(scrollContainerElement, "scroll", event => {
          this.detectScrollPosition(event);
        });
      }
    }
  }

  ngOnDestroy() {
    if (this.scrollListener) {
      this.scrollListener();
    }
  }
  @HostListener('scroll', ['$event'])
  onScroll(event: any) {
    if (!this.scrollContainer) {
      this.detectScrollPosition(event);
    }
  }

  detectScrollPosition(event:any) {
    let currentSection: any;
    const children = this.spyItems.map(item => {
      return this.document.getElementById(item)
    })
    let scrollTop = event.target.scrollTop;
    let parentOffset = event.target.offsetTop + this.scrollOffset;
    if (this.scrollContainer === "window") {
       scrollTop = event.target.scrollingElement.scrollTop;
       parentOffset = event.target.scrollingElement.offsetTop + this.scrollOffset;
    }
    for (let i = 0; i < children.length; i++) {
      const element = children[i];
      if (this.spyItems.some(item => item === element.id)) {
        if ((element.offsetTop - parentOffset) <= scrollTop) {
          currentSection = element.id;
        }
      }
    }
    if (currentSection !== this.currentSection) {
      this.currentSection = currentSection;
      this.sectionChange.emit(this.currentSection);
    }
  }
}
